.dm{background:var(--palette-white);}